import React, { ReactElement } from 'react';

import Error from './Error';

const Errors = ({
  errorMessages,
}: {
  errorMessages: Array<string>;
}): Array<ReactElement<Error>> => {
  return errorMessages.map((errorMessage, index) => (
    <Error key={index} errorMessage={errorMessage} />
  ));
};

export default Errors;
